import { Routes } from '@angular/router';

import { RoleGuard } from '../../../core/auth/role-guard';

export const noteRoutes: Routes = [
  {
    path: 'notes',
    title: 'Notes Administration',
    canActivate: [RoleGuard],
    data: {
      roles: ['SuperAdmin', 'Markets.Admin', 'Markets.Purchase', 'Markets.Sales', 'Markets.ProductDevelopment'],
    },
    children: [
      {
        path: 'list',
        title: 'Notes',
        loadComponent: () =>
          import('./features/notes/components/note-list/note-list.component').then(
            module => module.NoteListComponent
          ),
      },
      {
        path: 'details/:id',
        title: 'Note Details',
        loadComponent: () =>
          import('./features/notes/components/note-details/note-details.component').then(
            module => module.NoteDetailsComponent
          ),
      },
      {
        path: 'templates',
        title: 'Templates',
        canActivate: [RoleGuard],
        data: {
          roles: ['SuperAdmin', 'Markets.Admin'],
        },
        loadComponent: () =>
          import('./features/templates').then(module => module.TemplateListComponent),
      },
      {
        path: 'templates/:id',
        title: 'Template',
        canActivate: [RoleGuard],
        data: {
          roles: ['SuperAdmin', 'Markets.Admin'],
        },
        loadComponent: () =>
          import('./features/templates').then(module => module.TemplateFormComponent),
      },
      {
        path: 'categories',
        title: 'Categories',
        canActivate: [RoleGuard],
        data: {
          roles: ['SuperAdmin', 'Markets.Admin'],
        },
        loadComponent: () =>
          import('./features/categories').then(module => module.CategoryListComponent),
      },
      {
        path: 'categories/:id',
        title: 'Category',
        canActivate: [RoleGuard],
        data: {
          roles: ['SuperAdmin', 'Markets.Admin'],
        },
        loadComponent: () =>
          import('./features/categories').then(module => module.CategoryFormComponent),
      },
    ],
  },
];
